import React from 'react';
import { RISK_LEVELS } from '../lib/data';

// Risk pill with a leading dot and optional numeric score.
export default function RiskBadge({ level = 'unverified', score = null, showScore = false }) {
  const cfg = RISK_LEVELS[level] || RISK_LEVELS.unverified;
  return (
    <span className={`pill ${cfg.cls}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${cfg.dot}`} />
      {cfg.label}
      {showScore && score != null && <span className="tnum opacity-70">· {score}</span>}
    </span>
  );
}
